import onBeforeGanttRender from './onBeforeGanttRender';
import onBeforeTaskDisplay from './onBeforeTaskDisplay';
import onMouseMove from './onMouseMove';
import onGanttScroll from './onGanttScroll';
import onDataRender from './onDataRender';
import onGanttReady from './onGanttReady';
import onGridHeaderClick from './onGridHeaderClick';
import onTaskClick from './onTaskClick';
import onContextMenu from './onContextMenu';
import onParse from './onParse';
import onBeforeTaskMove from './onBeforeTaskMove';
import onAfterTaskAdd from './onAfterTaskAdd';
import onAfterTaskMove from './onAfterTaskMove';
import onGanttRender from './onGanttRender';
import onBeforeLinkUpdate from './onBeforeLinkUpdate';
import onBeforeLinkAdd from './onBeforeLinkAdd';
import onAfterTaskUpdate from './onAfterTaskUpdate';
import onAfterTaskDelete from './onAfterTaskDelete';
import autoSchedulingEvents from './autoScheduling';
import customEvents from './custom';
import onLinkClick from './onLinkClick';
import onTaskDblClick from './onTaskDblClick';
import exportEvents from './export';
import historyEvents from './history';
import onTaskIdChange from './onTaskIdChange';
import onGridResize from './onGridResize';
import domEvents from './dom';
import onEmptyClick from "./onEmptyClick";
import onDestroy from './onDestroy';
import onBeforeEditStart from './onBeforeEditStart';
import onEditStart from './onEditStart';
import onEditEnd from './onEditEnd';
import onRowDragEnd from './onRowDragEnd';
import onRowDragStart from './onRowDragStart';
import onBeforeRowDragMove from './onBeforeRowDragMove';
import onBeforeRowDragEnd from './onBeforeRowDragEnd';
import onRowDragMove from './onRowDragMove';
import onBeforeTaskDrag from './onBeforeTaskDrag';

class Events {
  #instance = null;

  init(instance) {
    this.#instance = instance;
    this.#attachEvents();
    this.#attachCustomEvents();
  }

  initForExport(instance) {
    this.#instance = instance;
    exportEvents(this.#instance);
    historyEvents(this.#instance);
    onBeforeGanttRender(this.#instance);
    onBeforeTaskDisplay(this.#instance);
    onMouseMove(this.#instance);
    onDataRender(this.#instance);
    onGanttReady(this.#instance);
    onTaskClick(this.#instance);
    onParse(this.#instance);
    onGridResize(this.#instance);
  }

  initForArchived(instance) {
    this.#instance = instance;
    onBeforeGanttRender(this.#instance);
    onBeforeTaskDisplay(this.#instance);
    onMouseMove(this.#instance);
    onDataRender(this.#instance);
    onGanttReady(this.#instance);
    onTaskClick(this.#instance);
    onParse(this.#instance);
    onGridResize(this.#instance);
    onGridHeaderClick(this.#instance);
    this.#attachCustomEvents();
  }

  #attachEvents() {

    onBeforeGanttRender(this.#instance);
    onGanttRender(this.#instance);
    onBeforeTaskDisplay(this.#instance);
    onMouseMove(this.#instance);
    onGanttScroll(this.#instance);
    onDataRender(this.#instance);
    onGanttReady(this.#instance);
    onGridHeaderClick(this.#instance);
    onTaskClick(this.#instance);
    onTaskDblClick(this.#instance);
    onContextMenu(this.#instance);
    onParse(this.#instance);
    onBeforeTaskMove(this.#instance);
    onAfterTaskAdd(this.#instance);
    onAfterTaskMove(this.#instance);
    onBeforeLinkUpdate(this.#instance);
    onBeforeLinkAdd(this.#instance);
    onAfterTaskUpdate(this.#instance);
    onAfterTaskDelete(this.#instance);
    onLinkClick(this.#instance);
    autoSchedulingEvents(this.#instance);
    onTaskIdChange(this.#instance);
    onGridResize(this.#instance);
    onEmptyClick(this.#instance);
    onDestroy(this.#instance);
    onBeforeEditStart(this.#instance);
    onEditStart(this.#instance);
    onEditEnd(this.#instance);
    onRowDragEnd(this.#instance);
    onRowDragStart(this.#instance);
    onBeforeRowDragMove(this.#instance);
    onBeforeRowDragEnd(this.#instance);
    onRowDragMove(this.#instance);
    onBeforeTaskDrag(this.#instance);
  }

  initDomEvents() {
    domEvents(this.#instance);
  }

  #attachCustomEvents() {
    customEvents(this.#instance);
  }
}

export default new Events();
